import React from 'react';

interface BrandLogoProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  showWordmark?: boolean;
}

export const BrandLogo: React.FC<BrandLogoProps> = ({
  size = 'md',
  className = '',
  showWordmark = false,
}) => {
  const sizeMap = {
    xs: 'w-6 h-6',
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16',
  };

  const pxMap = {
    xs: 24,
    sm: 32,
    md: 40,
    lg: 48,
    xl: 64,
  };

  return (
    <div className={`inline-flex items-center gap-2.5 select-none ${className}`}>
      <img
        src="/quickibible-icon.png"
        srcSet="/pwa-192x192.png 1x, /pwa-512x512.png 2x"
        alt="QuickiBible Q! Official Brand Logo"
        width={pxMap[size]}
        height={pxMap[size]}
        className={`${sizeMap[size]} object-contain rounded-xl drop-shadow-md shrink-0 transition-transform duration-200 group-hover:scale-105`}
      />
      {showWordmark && (
        <span className="font-bold tracking-tight text-white font-sans text-xl sm:text-2xl">
          Quick<span className="text-[#F97316] font-extrabold">!</span>Bible
        </span>
      )}
    </div>
  );
};
